export const getPricingPlans = (user: any | null = null) => {
    return [
        {
            name: 'Gratuit',
            planId: 'gratuit',
            price: '0 FCFA',
            period: '/mois',
            color: '#64748b',
            scopeText: 'Usage Particulier (B2C)',
            current: user?.role?.name === 'basic_user',
            features: [
                { text: 'Usage strictement personnel & particulier (B2C)', included: true },
                { text: 'Données de marché en fin de journée', included: true },
                { text: 'Simulateur de portefeuille (capital virtuel libre)', included: true },
                { text: 'Alertes de prix (5 alertes max)', included: true },
                { text: 'Nia IA — Analyste conversationnelle (5 msg/jour)', included: true },
                { text: 'Signaux Pro — Alertes techniques', included: false },
                { text: 'Analyse Globale du Marché (Heatmap + Sentiment IA)', included: false },
                { text: 'Nia IA — Accès illimité', included: false },
            ],
        },
        {
            name: 'Kanea Starter',
            planId: 'kanea_starter',
            price: '7 900 FCFA',
            period: '/mois',
            billingText: 'Facturé 7 900 FCFA chaque mois · sans engagement',
            scopeText: 'Usage Particulier (B2C)',
            color: '#10b981',
            current: user?.role?.name === 'paid_user',
            features: [
                { text: 'Usage strictement personnel & particulier (B2C)', included: true },
                { text: 'Nia IA — Accès illimité (conversations & données BRVM)', included: true },
                { text: 'Outils d\'analyse technique (RSI, OBV, Stochastique...)', included: true },
                { text: 'Analyse Globale du Marché (Heatmap + Sentiment IA)', included: true },
                { text: 'Alertes de prix (illimitées)', included: true },
                { text: 'Simulateur de portefeuille (capital virtuel libre)', included: true },
                { text: 'Signaux Pro — Alertes techniques', included: true },
                { text: 'Alertes de Valorisation par email', included: false },
                { text: 'Rééquilibrage Intelligent', included: false },
                { text: 'Watchlist IA', included: false },
            ],
        },
        {
            name: 'Kanea Pro',
            planId: 'kanea_pro',
            price: '6 650 FCFA',
            period: '/mois',
            billingText: 'Facturé 39 900 FCFA tous les 6 mois · engagement de 6 mois',
            scopeText: 'Usage Particulier (B2C)',
            color: '#3b82f6',
            popular: true,
            current: user?.role?.name === 'paid_user_pro',
            features: [
                { text: 'Usage strictement personnel & particulier (B2C)', included: true },
                { text: 'Nia IA — Accès illimité (conversations & données BRVM)', included: true },
                { text: 'Outils d\'analyse technique (RSI, OBV, Stochastique...)', included: true },
                { text: 'Analyse Globale du Marché (Heatmap + Sentiment IA)', included: true },
                { text: 'Signaux Pro — Alertes techniques', included: true },
                { text: 'Simulateur de portefeuille (capital virtuel libre)', included: true },
                { text: 'Alertes de Valorisation par email (sous-évaluation détectée)', included: true },
                { text: 'Rééquilibrage Intelligent', included: true },
                { text: 'Watchlist IA ✨ (Preview)', included: true },
                { text: 'Bonus exclusifs', included: false },
            ],
        },
        {
            name: 'Kanea Illimité',
            planId: 'kanea_illimite',
            price: '5 825 FCFA',
            period: '/mois',
            billingText: 'Facturé 69 900 FCFA par an · engagement de 12 mois',
            scopeText: 'Usage Particulier (B2C)',
            badgeText: 'VIP',
            color: '#8b5cf6',
            current: false, // VIP/Illimité has same role as Pro in B2C; differentiated off-platform
            features: [
                { text: 'Usage strictement personnel & particulier (B2C)', included: true },
                { text: 'Tout Kanea Pro (Nia IA illimitée, Alertes, Portefeuilles IA)', included: true },
                { text: 'Simulateur de portefeuille (capital virtuel libre)', included: true },
                { text: 'Rééquilibrage Intelligent', included: true },
                { text: 'Watchlist IA ✨ (Preview)', included: true },
                { text: 'Outils d\'analyse de l\'allocation de portefeuille', included: true },
                { text: 'Support prioritaire 24/7', included: true },
                { text: 'Accès anticipé aux nouveautés', included: true },
                { text: 'Bonus & rapports exclusifs', included: true },
            ],
        },
    ];
};
